const API_EKS_BASE_URL_BY_ENV = {
    PROD: 'https://api.onequince.com',
    DEV: 'https://api-dev.onequince.com',
    QA: 'https://api-qa.onequince.com',
    PRE_INTEG: 'https://api-pre-integ.onequince.com'
};
const API_ECS_BASE_URL_BY_ENV = {
    PROD: 'https://api.onequince.com',
    DEV: 'https://api-dev.onequince.com',
    QA: 'https://api-integ.onequince.com',
    PRE_INTEG: 'https://api-pre-integ.onequince.com'
};
const API_STORE_FRONT_RUNTIME_API_BY_ENV = {
    PROD: 'https://storefront-api.onequince.com/Production',
    DEV: 'https://storefront-integ-apigateway.onequince.com/Integration',
    QA: 'https://storefront-integ-apigateway.onequince.com/Integration',
    PRE_INTEG: 'https://storefront-integ-apigateway.onequince.com/Integration'
};
const API_STORE_FRONT_BFF_API_BY_ENV = {
    PROD: 'https://api-prod-public.onequince.com/bff-service',
    DEV: 'https://api-qa.onequince.com/bff-service',
    QA: 'https://api-qa.onequince.com/bff-service',
    PRE_INTEG: 'https://api-pre-integ.onequince.com/bff-service'
};
const API_SP_IMAGE_SERVICE_BY_ENV = {
    PROD: 'https://api.onequince.com/service',
    DEV: 'https://api-staging.onequince.com/service',
    QA: 'https://api-integ.onequince.com/service',
    PRE_INTEG: 'https://api-pre-integ.onequince.com'
};
const API_CUSTOMER_SERVICE_BY_ENV = {
    PROD: 'https://api.onequince.com/customers',
    DEV: 'https://api-staging.onequince.com/customers',
    QA: 'https://api-integ.onequince.com/customers',
    PRE_INTEG: 'https://api-pre-integ.onequince.com/customers'
};
const API_ECS_BASE_URL_BY_ENV_TO_BASE_URL_MAP = {
    EKS: API_EKS_BASE_URL_BY_ENV,
    ECS: API_ECS_BASE_URL_BY_ENV,
    RUNTIME: API_STORE_FRONT_RUNTIME_API_BY_ENV,
    BFF_SERVICE: API_STORE_FRONT_BFF_API_BY_ENV,
    IMAGE_SERVICE: API_SP_IMAGE_SERVICE_BY_ENV,
    CUSTOMER_SERVICE: API_CUSTOMER_SERVICE_BY_ENV
};

export { API_ECS_BASE_URL_BY_ENV_TO_BASE_URL_MAP };
//# sourceMappingURL=http-client.constants.js.map
